//
//
//
//
//
//
import init from '@/mixins/';
export default {
  props: {
    props: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  mixins: [init]
};